import type { UserModel } from '../../models';

export function sameUsername(left: string, right: string): boolean {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}

export function hasCompleteMembership(users: UserModel[] | undefined): users is UserModel[] {
  return (
    Array.isArray(users) &&
    users.length > 0 &&
    users.every(
      (user) =>
        typeof user?.name === 'string' &&
        user.name.trim().length > 0 &&
        Array.isArray(user.roles) &&
        user.roles.length > 0 &&
        user.roles.every((role) => typeof role === 'string' && role.trim().length > 0)
    ) &&
    new Set(users.map((user) => user.name.trim().toLowerCase())).size === users.length
  );
}

export function canManageMembership(users: UserModel[] | undefined, username: string): boolean {
  return !!username.trim() && hasCompleteMembership(users) && users.some((user) => sameUsername(user.name, username) && user.roles.includes('Administrator'));
}

export function membershipRemovalBlock(users: UserModel[] | undefined, username: string, target: UserModel): string | undefined {
  if (!username.trim() || !hasCompleteMembership(users)) {
    return 'membership-data-unavailable';
  }
  const member = users.find((user) => sameUsername(user.name, target.name));
  const actor = users.some((user) => sameUsername(user.name, username));
  if (!member || !actor) {
    return 'membership-data-unavailable';
  }
  if (!sameUsername(member.name, username) && !canManageMembership(users, username)) {
    return 'membership-admin-required';
  }
  if (users.length === 1) {
    return 'membership-last-member';
  }
  if (!users.some((user) => !sameUsername(user.name, member.name) && user.roles.includes('Administrator'))) {
    return 'membership-last-administrator';
  }
  return undefined;
}
